import Itinerary from './Itinerary';
import './Itinerary.scss';

export default Itinerary;
